import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import DatasetsCombobox from '@/components/datasets-combobox';
import TaskCombobox from '@/components/task-combobox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useFormSearchParams } from '@/hooks/use-form-search-params';
import { LeaderboardFiltersSchema } from '@/routes/(app)/(leaderboards)/lib/leaderboard-filters-schema';

const LeaderboardFilters = () => {
  const { t } = useTranslation();
  const { control, watch, setValue } =
    useFormContext<LeaderboardFiltersSchema>();

  const task = watch('task');

  useFormSearchParams('/app/leaderboards');

  return (
    <div className='flex flex-row gap-4'>
      <FormField
        control={control}
        name='task'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('leaderboards.form.task.label')}</FormLabel>
            <TaskCombobox
              {...field}
              onChange={(value) => {
                field.onChange(value);
                setValue('datasetIds', []);
              }}
            />
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name='datasetIds'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('leaderboards.form.dataset.label')}</FormLabel>
            <FormControl>
              <DatasetsCombobox
                task={task}
                values={field.value}
                {...field}
                placeholder={t('leaderboards.form.dataset.placeholder')}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default LeaderboardFilters;
